import { ReactNode } from 'react';
import './section-heading.css';

export interface SectionHeadingProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  spread?: boolean;
  wide?: boolean;
  className?: string;
  id?: string;
  titleId?: string;
}

export function SectionHeading({
  title,
  description,
  action,
  spread = false,
  wide = false,
  className = '',
  id,
  titleId,
}: SectionHeadingProps) {
  const classes = [
    'section-heading',
    spread ? 'section-heading--spread' : '',
    wide ? 'section-heading--wide' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (spread && action) {
    return (
      <div className={classes} id={id}>
        <div>
          <h2 id={titleId}>{title}</h2>
          {description && <p>{description}</p>}
        </div>
        {action}
      </div>
    );
  }

  return (
    <div className={classes} id={id}>
      <h2 id={titleId}>{title}</h2>
      {description && <p>{description}</p>}
      {action}
    </div>
  );
}
